import { Column, Row } from '@tanstack/react-table';

export const exportTableData = <T extends object>(columns: Column<T, unknown>[], rowData: Row<T>[], fileName: string) => {
    const tableColumnKeys = columns
        .filter((column) => ('id' in column && column.id !== 'select') || !('id' in column))
        .map((column) => column.id) as string[];

    const tableColumnHeaders = columns
        .filter((column) => !column.id || column.id !== 'select')
        .map((column) => column.columnDef.meta?.headerText);

    const filteredData = rowData.map((item) =>
        tableColumnKeys.map((key) => {
            let value = item.getValue(key);

            if (value === undefined || value === null) {
                return '';
            }

            if (typeof value === 'string') {
                value = value.replace(/"/g, '""'); // Escape double quotes
                return `"${value}"`; // Wrap value in quotes
            }

            return value;
        }),
    );

    const csvContent = [
        tableColumnHeaders.join(','), // Header row
        ...filteredData.map((row) => row.join(',')),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    // Create and trigger a download link without adding to the DOM
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.csv`;
    link.click();

    // Clean up memory
    URL.revokeObjectURL(url);
};
